/* eslint-disable @typescript-eslint/naming-convention */
import classNames from 'clsx';
import React from 'react';

import type { IconsGrid } from '@swf/cms';
import { CMSHTML, CMSImage } from '@swf/cms';

import styles from './CMSIconsGrid.scss';

const CMSIconsGrid: React.FC<IconsGrid> = ({
  items,
  icon_alignment,
  number_of_columns,
  number_of_columns_on_mobile
}) =>
  items ? (
    <div
      className={classNames(
        styles.grid,
        styles[`col${number_of_columns}`],
        styles[`mobileCol${number_of_columns_on_mobile}`]
      )}
    >
      {items.map(({ icon, text }, index) => {
        const hasPredefinedDimensions = icon.width && icon.height;
        return (
          <div
            key={index}
            className={classNames(styles.gridItem, icon_alignment && styles[icon_alignment])}
          >
            <CMSImage
              {...icon}
              className={classNames(styles.icon, { [styles.dimensions]: !hasPredefinedDimensions })}
            />
            <CMSHTML className={styles.text} {...text} />
          </div>
        );
      })}
    </div>
  ) : null;

export default CMSIconsGrid;
